<template>
  <b-card>
    <div
        class="card-transaction-product"
    >
      <div
          class="card-transaction-product-header align-item-center flex-nowrap"
      >
        <div>
          <h3 class="ul-widget__head-title mb-1">
            Remittance Advice
          </h3>
          <small>{{ item.remittance_commission.length }} Commissions </small>


          <ul>
            <li>Status: {{ item.status }}</li>
            <li v-if="item.paid_date">Paid date: {{ formatDate(item.paid_date) }}</li>
            <li v-if="item.paid_by">Paid by: {{ item.paid_by.name }}</li>
            <li>Remittance Amount: <b>{{ currencyInvoice(item.amount) }}</b></li>
          </ul>

          <p v-for="(document, index) in item.documents" :key="index + 'document'">
            <a  :href="document.file" target="_blank">
              Download Remittance PDF
            </a>
          </p>


          <small class="text-muted ml-8"
          >Date created:
            <span class="font-weight-500">{{
                formatDate(item.created_date)
              }}</span>
          </small>
        </div>
      </div>
    </div>
  </b-card>
</template>

<script>
import {clientHelpers} from '@/mixins/clientHelpers';
import {currencyFormat} from "@/mixins/currencyFormat";
import {textHelpers} from "@/mixins/textHelpers";
import { dateFormat } from "@/mixins/dateFormat";

export default {
  name: 'RemittanceCard',
  mixins: [clientHelpers, currencyFormat, textHelpers, dateFormat],
  props: {
    item: {
      type: Object,
      required: true
    }
  },
  computed: {

  },
  data () {
    return {

    }
  }
}
</script>
